import axios from '../../axios-dashboard';
import * as actionTypes from './actionTypes';

export const fetchAlertsStart = () => {
    return  {
        type: actionTypes.ALERTS_FETCH_START
    }
};

export const fetchAlertsSuccess = (alerts) => {
    return {
        type: actionTypes.ALERTS_FETCH_SUCCESS,
        alerts: alerts,
    }
};

export const fetchAlertsFail = (error) => {
    return {
        type: actionTypes.ALERTS_FETCH_FAIL,
        error: error,
    }
};

export const fetchAlerts = (token, filter, page) => {
    return dispatch => {
        if (!token) {
            return
        }
        dispatch(fetchAlertsStart());
        let url = "/alerts";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'getAlerts',
            filter: filter,
            page: {
                page: page,
                pageSize: 25,
            }
        }).then(response => {
            dispatch(fetchAlertsSuccess(response.data))
        }).catch(err => {
            dispatch(fetchAlertsFail(err.response.data.error))
        })
    }
};